import API from "..";
import { checkAPIResponse } from "../helpers";

export default class MethodExternalLab {
  /**
   * @param {int} methodFacilityID
   * @param {String} laboratoryName
   * @param {bool} isActive
   * @param {bool} isAccreditedTest
   * @param {bool} isMETP
   * @param {Number} testCostUSD
   * @param {Number} targetTurnaroundInDays
   * @param {Number} minimumSampleAmount
   * @param {String} minimumSampleAmountUoM
   * @param {String} createdByEmail 
   * @param {Datetime} createdDate 
   * @param {String} lastModifiedByEmail
   * @param {Datetime} lastModifiedDate
   */

  constructor({
    methodFacilityID,
    laboratoryName,
    isActive,
    isAccreditedTest,
    isMETP,
    testCostUSD,
    targetTurnaroundInDays,
    minimumSampleAmount,
    minimumSampleAmountUoM, 
    createdByEmail,
    createdDate,
    lastModifiedByEmail,
    lastModifiedDate}) {
    this.methodFacilityID = methodFacilityID;
    this.laboratoryName = laboratoryName;
    this.isActive = isActive;
    this.isAccreditedTest = isAccreditedTest;
    this.isMETP = isMETP;
    this.testCostUSD = testCostUSD;
    this.targetTurnaroundInDays = targetTurnaroundInDays;
    this.minimumSampleAmount = minimumSampleAmount;
    this.minimumSampleAmountUoM = minimumSampleAmountUoM;
    this.createdByEmail = createdByEmail;
    this.createdDate = createdDate;
    this.lastModifiedByEmail = lastModifiedByEmail;
    this.lastModifiedDate = lastModifiedDate;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get(`/methodExternalLab?includeInactive=true`);
    return data.result.map((d) => new MethodExternalLab(d));
  }

  static async getAllActive() {
    const api = await API();
    const { data } = await api.get(`/methodExternalLab?includeInactive=false`);
    return data.result.map((d) => new MethodExternalLab(d));
  }

  static async get(methodFacilityID, laboratoryName) {
    const api = await API();
    const { data } = await api.get(`/methodExternalLab`, {
      params: {
        methodFacilityID,
        laboratoryName,
        includeInactive: true,
      },
    });
    if (data.result.length > 0) {
      return new MethodExternalLab(data.result[0]);
    }
    else {
      return null;
    }
  }

  static async add(info) {
    const api = await API();
    const response = await api.post(`/methodExternalLab`, info);
    checkAPIResponse(response);
    return new MethodExternalLab(response.data.result);
  }

  static async update(info) {
    const api = await API();
    const response = await api.put(`/methodExternalLab`, info);
    checkAPIResponse(response);
    return new MethodExternalLab(response.data.result);
  }
}